import script from "./paymentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./paymentModal.vue?vue&type=script&setup=true&lang=js"

import "./paymentModal.vue?vue&type=style&index=0&id=16027f45&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16027f45"]])

export default __exports__